
<modal :state="state" :index="index" @toggle-modal="cancel">
  <div slot="body">
    <crayon tag="h3" class="modal-title" color="Red">Form in Progress</crayon>
    <p>Someone in your entity is already working on this form. Would you like to edit the form in progress, or start a new form?</p>
    <div class="cta">
      <button type="button" class="btn green outline" @click="startForm">Start a New Form</button>
      <button type="button" class="btn blue outline" @click="editForm">Edit Form</button>
    </div>
  </div>
</modal>
